import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
import { getInstanceAsync } from '@/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountCreation',
  setup(__props) {

const urlParams = new URLSearchParams(window.location.search)
const jsonPayload = urlParams.get('payload') || '{}'
const payload = JSON.parse(jsonPayload)

onMounted(async () => {
  const auth = await getInstanceAsync()

  if (auth.isAuthenticated) {
    if (payload.RedirectUrl != null) {
      window.location.replace(payload.RedirectUrl)
    } else {
      window.location.replace('/')
    }
  }

  const url = `api/v2/Users/${payload.UserId}/invitation/${payload.InvitationId}/status`
  const response = await fetch(url)

  if (response.ok) {
    const data = await response.text()
    const invitationStatus = parseInt(data, 10)

    if (invitationStatus === 0 && payload.SetPasswordUrl != null) {
      window.location.replace(payload.SetPasswordUrl)
    } else if (invitationStatus === 1 && payload.RedirectUrl != null) {
      window.location.replace(payload.RedirectUrl)
    } else {
      window.location.replace('/')
    }
  } else {
    window.location.replace('/')
  }
})

return { __sfc: true,urlParams, jsonPayload, payload }
}

})